import React from 'react'
import { Card, Button, Container, Row, Col } from 'react-bootstrap'
import './publications-manifestos.css'

export default function PublicationsManifesters() {
  const manifestos = [
    {
      title: 'Manifiesto por Palestina',
      description: 'Posicionamiento de activistas y educadoras menstruales sobre la situación en Palestina.',
      buttonLabel: 'Leer documento',
      href: `${process.env.PUBLIC_URL}/pdfs/manifiesto-palestina.pdf`,
      tag: 'Manifiesto'
    },
    {
      title: 'Manifiesto por la Justicia Menstrual',
      description: 'Declaración de principios sobre justicia, equidad y derechos menstruales.',
      buttonLabel: 'Leer documento',
      href: `${process.env.PUBLIC_URL}/pdfs/justicia.pdf`,
      tag: 'Manifiesto'
    },
    {
      title: 'Guía Activismo Menstrual',
      description: 'Guía práctica con herramientas y estrategias para activismo menstrual comunitario.',
      buttonLabel: 'Ver documento',
      href: `${process.env.PUBLIC_URL}/pdfs/guia.pdf`,
      tag: 'Guía'
    }
  ]

  return (
    <section className='publications-manifestos section__padding'>
      <Container>
        <h2 className='publications-section__title'>Manifiestos, guías</h2>
        <Row className='g-4'>
          {manifestos.map((item, index) => (
            <Col key={index} md={6} lg={4} className='mb-4'>
              <Card className='publications-card border-0 h-100'>
                <div className='publications-card__header'>
                  <span className='publications-card__tag'>{item.tag}</span>
                </div>
                <Card.Body className='publications-card__body d-flex flex-column'>
                  <h5 className='publications-card__title'>{item.title}</h5>
                  <p className='publications-card__description'>{item.description}</p>
                  <Button 
                    href={item.href}
                    target='_blank'
                    rel='noreferrer'
                    className='publications-card__button mt-auto'
                  >
                    {item.buttonLabel}
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}
